module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-box",
    class: _vm.selectorClass,
    style: (_vm.position)
  }, [(_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-box__content"
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.triangleFirst) ? _c('div', {
    staticClass: "popover-box__triangle",
    class: _vm.triangleClass,
    style: (_vm.offset)
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dafbd64","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/PopoverBox.vue
// module id = 2144
// module chunks = 0